import axios from '../setup/axios';

export default function initVideo() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.article-video, .two-column.has-video, .hero.has-video').forEach($container => {
        const $trigger = $container.querySelector('.video-icon');
        const $videoContainer = $container.querySelector('.video-container');
        const $articleVideoContainer = $container.querySelector('.article-video-container');
        const $image = $container.querySelector('img');
        let $video = $container.querySelector('iframe');
        let $videoLink = null;
        let $blockedContentID = null;

        const $blockedContent = $container.querySelector('.uc-embedding-container');
        if ($blockedContent) {
            $blockedContentID = $blockedContent.id;
        }

        if (!$video) {
            $video = $container.querySelector('video');
        }

        if ($video?.src) {
            $videoLink = $video.src;
        } else if ($articleVideoContainer?.querySelector('source')?.src) {
            $videoLink = $articleVideoContainer.querySelector('source').src;
        } else if ($videoContainer?.dataset?.videolink) {
            $videoLink = $videoContainer.dataset.videolink;
            delete $videoContainer.dataset.videolink;
        } else if ($container.dataset.videolink) {
            $videoLink = $container.dataset.videolink;
        }

        const $setPreview = $videoLink?.includes('youku');

        if (
            $setPreview &&
            (
                ($image?.classList.contains('youku-image')) ||
                ($articleVideoContainer?.classList.contains('youku-background'))
            )
        ) {
            const afterEmbed = $videoLink.split('/')[4];
            const videoID = afterEmbed.substring(0, afterEmbed.indexOf('='));
            const clientID = afterEmbed.substring(afterEmbed.lastIndexOf('=') + 1);
            const url = `https://api.youku.com/videos/show.json?video_id=${videoID}&client_id=${clientID}`;

            axios.get(url)
                .then(response => {
                    let responseImage = response?.data?.bigThumbnail || response?.data?.thumbnail || null;

                    if (responseImage) {
                        if ($image?.classList?.contains('youku-image')) {
                            $image.setAttribute('src', responseImage);
                            $image.classList.remove('is-hidden');
                        }

                        if ($articleVideoContainer?.classList?.contains('youku-background')) {
                            $articleVideoContainer.style.backgroundImage = `url('${responseImage}')`;
                        }

                        if ($blockedContentID && $blockedContent?.id === $blockedContentID) {
                            $blockedContent.style.backgroundImage = `url('${responseImage}')`;
                            $blockedContent.style.backgroundSize = 'cover';
                        }
                    }
                })
                .catch(console.log);
        }

        function hideVideo() {
            const $currentVideo = $container.querySelector('iframe');
            if ($currentVideo?.src) {
                $currentVideo.setAttribute('data-src', $currentVideo.src);
                $currentVideo.src = '';
            }

            $container.classList.remove('video-visible');
        }

        if ($trigger) {
            $trigger.addEventListener('click', event => {
                event.preventDefault();

                if ($video) {
                    const source = $video.querySelector('source')?.src;
                    if (source) {
                        $video.src = source;
                    }

                    if (!prefersReducedMotion && $video.src) {
                        if ($video.nodeName === 'IFRAME') {
                            $video.src += $video.src.includes('?')
                                ? '&autoplay=1&mute=1&controls=1'
                                : '?autoplay=1&mute=1&controls=1';
                        } else {
                            $video.setAttribute('autoplay', 'true');
                            $video.setAttribute('controls', 'true');
                            $video.setAttribute('allow', 'autoplay encrypted-media');
                        }
                    }
                }

                $container.classList.add('video-visible');
            });
        }

        if ($videoContainer) {
            $videoContainer.addEventListener('click', event => {
                event.preventDefault();
                hideVideo();
            });
        }

        document.addEventListener('keydown', function (e) {
            if (e.code === 'Escape') {
                hideVideo();
            }
        });
    });

    document.querySelectorAll('.two-column .video-icon').forEach($link => {
        $link.addEventListener('click', event => {
            event.preventDefault();

            const parent = $link.closest('.two-column');
            let video = parent?.querySelector('iframe') || parent?.querySelector('video');

            if (video) {
                const dataSrc = video.getAttribute('data-src');
                if (dataSrc && !prefersReducedMotion) {
                    setTimeout(() => {
                        video.setAttribute('src', dataSrc);
                    }, 100);
                }

                parent.classList.add('video-visible');
            }
        });
    });
}
